const EXCLUDED_PATIENT_TYPES = new Set(["na", "declined", "cancelled"]);

export const escapeCsvValue = (value) => {
  if (value === null || value === undefined) {
    return '""';
  }
  const stringValue = typeof value === "string" ? value : String(value);
  return `"${stringValue.replace(/"/g, '""')}"`;
};

const calculateScheduledPatients = (patients = []) => {
  return patients.filter((patient) => {
    const type = patient.patient_type ? patient.patient_type.toLowerCase() : "";
    return !EXCLUDED_PATIENT_TYPES.has(type);
  }).length;
};

export const buildDoctorsCsv = (doctors = []) => {
  const headers = [
    "Name",
    "Email",
    "Scheduled Patients Today (no NA or Declined)",
    "Daily Notes",
    "Locked Notes",
    "Most Recent",
    "First Note",
    "Total Notes",
  ];

  const rows = doctors.map((doctor) => [
    doctor.user_name || "",
    doctor.user_email || "",
    doctor.scheduledPatientsToday ?? calculateScheduledPatients(doctor.patients || []),
    doctor.dailyNotes ?? 0,
    doctor.lockedNotes ?? 0,
    doctor.recentNote || "",
    doctor.firstNote || "",
    doctor.totalNotes ?? 0,
  ]);

  return [headers, ...rows]
    .map((row) => row.map(escapeCsvValue).join(","))
    .join("\n");
};
